export default __webpack_public_path__ + "static/media/Animals_21.998cfcfa.png";